import React, { useEffect, useState } from "react";
// import SportsLeftbar from '../../components/sports/SportsLeftbar';
import SportsRight from "../../components/sports/SportsRight";
// import SportsCenter from '../../components/BetGame/SportsCenter';
import { socket } from "../../common/cores/socket";
import connect from "react-redux/lib/connect/connect";
import { ClearBetStore } from "../../common/actions/betAction";
import {
  ClearSportsList,
  GetSportsList,
  SetActiveId,
  SetSportsList
} from "../../common/actions/sportsAction";
import $ from 'jquery';
import {
  convertResultType,
  ResizeSportsLiveIframe,
  ResizeVirtualIframe,
  getBetList,
  isEmpty,
  toastr,
  dateFormation,
  sortBet365Market
} from "../../common/cores";
// import { SlideDown } from "../../utils";
import { SetPageInfo } from "../../common/actions/pageAction";
import { per_page } from "../../common/cores/keys";
import MarketItem from "./MarketItem";
import { betGames, lotusgame } from "../../utils/names";
import { betGameAllowMarket, lotusGameAllowMarket } from "../../common/cores/betGameMarkets";

const BetGameCenter = props => {
  let gamelists = props.sports.data;
  const { url } = props.sports;

  const { match, type, betgametype } = props;
  const [showLeft, setShowLeft] = useState(false);
  const [betItem, setBetItem] = useState({});
  const [selectedList, setSelectedList] = useState({});
  const [betGame, setBetGame] = useState("Soccer");
  const [leagues, setLeagues] = useState([
    {
      name: "World Cup",
      id: "worldCup"
    },
    {
      name: "Premiership",
      id: "premiership"
    },
    {
      name: "Superleague",
      id: "superleague"
    },
    {
      name: "Euro Cup",
      id: "euroCup"
    }
  ]);
  const [league, setLeague] = useState("worldCup");
  const [list, setList] = useState("");
  const [iframeUrl, setIframeUrl] = useState("World Cup");
  const [markets, setMarkets] = useState([]);

  useEffect(() => {
    getSportsList()
    props.SetSportsList([]);
    props.SetActiveId("");
    setMarkets([]);
  }, [betGame, league])

  useEffect(() => {
    if (isEmpty(gamelists))
      setMarkets([]);
  }, [props.sports.data])
  const onBetGame = id => {
    if (betgametype === "bet365") {
      setBetGame(id);
      let index = betGames.findIndex(item => item.id === id);
      if (index < 0) index = 0;
      setLeagues(betGames[index].leagues);
      setLeague(betGames[index].leagues[0].id);
      setIframeUrl(betGames[index].leagues[0].name)
    }
    else {
      setBetGame(id);
      let index = betGames.findIndex(item => item.id === id);
      if (index < 0) index = 0;
      setLeagues(betGames[index].leagues);
      setLeague(betGames[index].leagues[0].id);
      setIframeUrl(betGames[index].leagues[0].name)
    }
  };

  const onLeague = (id) => {
    setLeague(id);
    let index = leagues.findIndex(item => item.id === id);
    if (index < 0) index = 0;
    setIframeUrl(leagues[index].name)
  }

  const onList = (key) => {
    if (isEmpty(gamelists[gamelists.findIndex((item) => item.key === key)])) return;
    let gameDate = new Date(gamelists[gamelists.findIndex((item) => item.key === key)].date);
    let dateNow = new Date()



    // if(gameDate < dateNow) {
    //     getSportsList();
    //     return toastr.warning("배팅시간이 지났습니다.");
    // }


    // console.log('betGame: ', betGame);
    if (isEmpty(gamelists)) return;

    setList(key);
    setSelectedList(gamelists[gamelists.findIndex((item) => item.key === key)]);
    let betMarkets = gamelists[gamelists.findIndex((item) => item.key === key)].markets;
    if (isEmpty(betMarkets)) return;
    let lists = [];
    // console.log('betMarkets: ', betMarkets);
    let allowMarkets = [];
    if (betgametype === "bet365") {
      allowMarkets = betGameAllowMarket.find(list => list.id === betGame).allowMarkets;
    }
    else {
      allowMarkets = lotusGameAllowMarket.find(list => list.id === betGame).allowMarkets;
    }
    // console.log('allowMarkets: ', allowMarkets, betGame);
    Object.keys(betMarkets).forEach(item => {
      let marketList = {}
      marketList.name = item;
      if (!isEmpty(allowMarkets) && (allowMarkets.findIndex(market => market.name === item) > -1)) {
        marketList.markets = betMarkets[item];
        if (betGame === "Soccer") {
          // item ==
          marketList.markets = marketList.markets.filter(market => {
            const patt = /\[|,/i;
            return !patt.test(market.home);
          })
        }
        lists.push(marketList);
      }
    });
    let newLists = sortBet365Market(lists)
    setMarkets(newLists);
  }
  useEffect(
    () => {
      // props.ClearBetStore();
      // props.ClearSportsList();
      if (gamelists.length != 0) props.SetActiveId(gamelists[0].key);
      if (!isEmpty(props.sports.activeId)) onList(props.sports.activeId);
      else {
        onList(props.sports.activeId);
      }
    },
    [props.sports.activeId]
  );
  useEffect(() => {
    return (() => {
      setIframeUrl("")
    })
  }, []);
  const roomObj = {
    pageType: "virtual",
    sportType: betGame,
    gameType: "all",
    sportId: "all",
    betGame: betGame,
    league: league
  };
  const roomData = {
    MessageType: "RoomType",
    data: roomObj
  };
  if (window.ws.readyState === 1)
    window.ws.send(JSON.stringify(roomData));
  props.SetPageInfo(roomObj);
  ResizeVirtualIframe();
  ResizeVirtualIframe();
  // }, []);

  const getSportsList = data => {
    // socket.emit('room', roomObj);
    setMarkets([]);
    const params = {
      ...roomObj,
      sportType: betGame,
      league: league
      // ...data
    };
    props.GetSportsList(params);
  };

  useEffect(
    () => {
      // SlideDown();
      getSportsList();
      if (window.ws.readyState === 1)
        window.ws.send(JSON.stringify(roomData));
    },
    [betGame, league]
  );

  const onSetShowLeft = () => {
    setShowLeft(!showLeft);
  };
  useEffect(() => {
    let betItem;
    if (betgametype === "bet365") {
      betItem = betGames.find(item => item.id === type)
    }
    else {
      betItem = lotusgame.find(item => item.id === type)
    }
    setBetItem(betItem);
    onBetGame(type)
    $(document).ready(function () {
      $("#vframe1")[0].height = $("#vframe1")[0].offsetWidth * 9 / 16; //플레이어를 16:9비율로 맞춤
    });
  }, [type]);

  const getIfreamUrl = id => {
    let pattern = new RegExp("leaguesName", "i");
    // console.log(id)
    let newUrl = String(url).replace(pattern, id);
    return newUrl;
  };

  let marketcnt = 0;
  if (
    isEmpty(gamelists[gamelists.findIndex(item => item.key === list)]) == false
  ) {
    marketcnt =
      gamelists[gamelists.findIndex(item => item.key === list)].markets
        .wintielose.length +
      gamelists[gamelists.findIndex(item => item.key === list)].markets.oneteam
        .length +
      gamelists[gamelists.findIndex(item => item.key === list)].markets.handicap
        .length +
      gamelists[gamelists.findIndex(item => item.key === list)].markets
        .ryangteam.length +
      gamelists[gamelists.findIndex(item => item.key === list)].markets
        .underover.length;
  }

  return (
    <div className="contents_box_left">
      <div className="con_box00">
        <div className="s_tab_wrap w-100 overflow-auto">
          <ul className="d-flex">
            {betGames.map((item, index) => {
              if (betGame === item.id)
                return (
                  <li key={index} onClick={() => onBetGame(item.id)}>
                    <a>
                      <span className="s_tabon">
                        <img
                          src="../images/swip/icon_football.png"
                          width="20px"
                        />
                        &nbsp;{item.name}
                      </span>
                    </a>
                  </li>
                );
              else
                return (
                  <li key={index} onClick={() => onBetGame(item.id)}>
                    <a>
                      <span className="s_tab">
                        <img
                          src="../images/swip/icon_basketball.png"
                          width="20px"
                        />
                        &nbsp;{item.name}
                      </span>
                    </a>
                  </li>
                );
            })}
          </ul>
        </div>
      </div>
      <div className="con_box00">
        <div className="s_tab_wrap">
          <ul className="d-flex">
            {leagues.map((item, index) => {
              return (
                <button
                  data-v-75fb5770=""
                  className={`button text ${league === item.id && "active"}`}
                  style={{
                    backgroundColor: "#1c212e",
                    border: "1px solid #1c212e",
                    borderRadius: "3px",
                    fontSize: "12px",
                    marginTop: "10px",
                    marginRight: "10px",
                    color: "#ececec",
                    cursor: "pointer"
                  }}
                  key={index}
                  onClick={() => onLeague(item.id)}
                >
                  <span data-v-75fb5770="" className="text">
                    {item.name}
                  </span>
                </button>
              );
            })}
          </ul>
        </div>
      </div>

      <div className="con_box00">
        <div className="s_tab_wrap">
          <ul className="d-flex">
            {gamelists.map((item, index) => {
              return (
                <button
                  key={index}
                  data-v-75fb5770=""
                  className={`button text ${league === item.id && "active"}`}
                  style={{
                    backgroundColor: "#1c212e",
                    border: "1px solid #1c212e",
                    borderRadius: "3px",
                    fontSize: "12px",
                    marginTop: "10px",
                    marginRight: "10px",
                    color: "#ececec",
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    props.SetActiveId(item.key);
                  }}
                >
                  <span data-v-75fb5770="" className="text">
                    {getBetList(item)}
                  </span>
                </button>
              );
            })}
          </ul>
        </div>
      </div>
      <div className="sport_betting_area" style={{ marginTop: "10px" }}>
        <div style={{ display: "block", maxWidth: "830px", margin: "auto" }}>
          <div
            id="virtual_iframe_parent"
            data-v-183c8283=""
            data-v-75fb5770=""
            className="betIframe"
            style={{ display: "block" }}
          >
            <iframe
              height="100%"
              id="vframe1"
              title="virtualIframe"
              scrolling="no"
              src={getIfreamUrl(iframeUrl)}
              frameBorder="0"
              allowFullScreen="yes"
            />
          </div>
        </div>
        <div className="sport_betting_area_box">
          <div className="sport_title_wrap">
            <div className="sport_title">
              <div className="sport_league">
                {!isEmpty(
                  gamelists[gamelists.findIndex(item => item.key === list)]
                ) &&
                  gamelists[gamelists.findIndex(item => item.key === list)]
                    .date}
                &nbsp;&nbsp;
                {/* <img src="../images/swip/icon02.png"/> */}
                &nbsp;&nbsp;
                {!isEmpty(
                  gamelists[gamelists.findIndex(item => item.key === list)]
                ) &&
                  gamelists[gamelists.findIndex(item => item.key === list)]
                    .title}
              </div>
            </div>
            {/* <div className="sport_title_list">
                        <ul>
                            <li className="sport_date">{!isEmpty(gamelists[gamelists.findIndex((item) => item.key === list)]) && gamelists[gamelists.findIndex((item) => item.key === list)].date}</li>
                            <li className="sport_etc">승무패</li>
                            <li className="sport_team1"><span className="team_l">{!isEmpty(gamelists[gamelists.findIndex((item) => item.key === list)]) && gamelists[gamelists.findIndex((item) => item.key === list)].home}</span><span className="team_r">&nbsp;1.03</span></li>
                            <li className="sport_tie"><span className="tie_d font06">9.60</span></li>
                            <li className="sport_team2"><span className="team_l">1.03&nbsp;</span><span className="team_r">{!isEmpty(gamelists[gamelists.findIndex((item) => item.key === list)]) && gamelists[gamelists.findIndex((item) => item.key === list)].away}</span></li>
                            <li className="sport_more">+{marketcnt}</li>
                        </ul>
                    </div> */}
            <div className="sport_more_wrap">
              <div className="sport_more_box">
                {markets.map((item, index) => {
                  return (
                    <MarketItem
                      market={item}
                      key={index}
                      date={selectedList}
                      betgametype={betgametype}
                      getSportsList={getSportsList}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  sports: state.sports,
  betgametype: state.sports.betgametype
});

export default connect(mapStateToProps, {
  SetPageInfo,
  GetSportsList,
  SetActiveId,
  SetSportsList
})(BetGameCenter);


// WEBPACK FOOTER //
// ./src/components/BetGame/BetGameCenter.js